// extracted by mini-css-extract-plugin
export var container = "_lk-0";
export var segment = "_lk-2";
export var segmentActive = "_lk-3";
export var track = "_lk-1";